import { Icon, SvgIcon } from "@mui/material";

export const CustomCheckIcon = (): JSX.Element => (
	<Icon>
		<img
			src="https://vladiator-labs-ag.imgix.net/vido-checkmark.png"
			height={20}
			width={20}
			alt="checkmark"
		/>
	</Icon>
);

export function CeloIcon(): JSX.Element {
	return (
		<SvgIcon>
			<svg
				version="1.1"
				viewBox="0 0 2500 2500"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="1250" cy="1250" r="1250" fill="#4e632a" />
				<path
					fill="#fcf6f1"
					d="m1949.2 546.15h-1398.6v1407.7h1398.7v-491.4h-232.1c-80 179.3-260.1 304.1-466.2 304.1-284.1 0-514.2-233.6-514.2-517.5 0-284 230.1-515.6 514.2-515.6 210.1 0 390.2 128.9 470.2 312.1h228.1v-499.4z"
				/>
			</svg>
		</SvgIcon>
	);
}

export function CeloBaklavaIcon(): JSX.Element {
	return (
		<SvgIcon>
			<svg
				version="1.1"
				viewBox="0 0 2500 2500"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="1250" cy="1250" r="1250" fill="#625948" />
				<path
					fill="#fcf6f1"
					d="m1949.2 546.15h-1398.6v1407.7h1398.7v-491.4h-232.1c-80 179.3-260.1 304.1-466.2 304.1-284.1 0-514.2-233.6-514.2-517.5 0-284 230.1-515.6 514.2-515.6 210.1 0 390.2 128.9 470.2 312.1h228.1v-499.4z"
				/>
			</svg>
		</SvgIcon>
	);
}

export function NymIcon(): JSX.Element {
	return (
		<SvgIcon>
			<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
				<circle
					cx="256"
					cy="256"
					r="244.68"
					fill="#000000"
					stroke="#fa704e"
					strokeWidth="19.589"
				/>
				<g
					transform="matrix(.82103 0 0 .82103 70.21 139.34)"
					fill="#fff"
					strokeWidth="5.6572"
				>
					<path d="m98.623 83.324h-0.35867v102.3l-44.029-102.13-0.05974-0.17509h-53.528v117.54h28.616v-102.48l44.208 102.3 0.0594 0.17537h53.349v-117.54h-0.2987z" />
					<path d="m97.616 82.691h29.911v118.8h-54.463l-0.1997-0.5844-42.953-99.401v99.985h-29.912v-118.8h54.643l0.19953 0.58476 42.774 99.219zm0.64775 102.94-44.029-102.13-0.059741-0.17509h-53.528v117.54h28.616v-102.48l44.208 102.3 0.0594 0.17481h53.349v-117.54h-28.616z" />
					<path d="m451.63 83.324h-53.707l-0.06 0.23345-27.361 102.54-27.421-102.54-0.06-0.23345h-54.125v117.54h28.616v-101.66l27.062 101.43 0.06 0.23364h51.556l0.06-0.23364 27.062-101.43v101.66h28.616v-117.54z" />
					<path d="m397.42 82.691h55.159v118.8h-29.911v-97.358l-25.786 96.645-2e-3 6e-3 -0.18046 0.70659h-52.568l-0.18103-0.70659-2e-3 -6e-3 -25.786-96.645v97.358h-29.911v-118.8h55.279l0.18046 0.70637 2e-3 0.0065 26.792 100.18 26.733-100.18 2e-3 -0.0062zm-26.915 103.4-27.421-102.54-0.0594-0.23345h-54.125v117.54h28.616v-101.66l27.062 101.43 0.06 0.23308h51.557l0.0594-0.23308 27.062-101.43v101.66h28.616v-117.54h-54.006l-0.06 0.23345z" />
					<path d="m242.84 83.324h-0.17933l-0.06 0.11673-33.993 57.717-34.171-57.717-0.06-0.11673h-33.096l0.2987 0.46688 52.631 89.056v28.013h28.616v-28.013l52.632-89.056 0.2987-0.46688h-0.5974z" />
					<path d="m242.26 82.691h34.666l-0.91251 1.4258-52.539 88.9v28.476h-29.911v-28.476l-52.539-88.9-0.91194-1.4258h34.665l0.23025 0.44939 33.599 56.751 33.423-56.751zm0.34057 0.74961-33.993 57.718-34.172-57.718-0.0594-0.11672h-33.096l0.2987 0.46688 52.631 89.056v28.012h28.616v-28.012l52.632-89.056 0.2987-0.46688h-33.096z" />
				</g>
			</svg>
		</SvgIcon>
	);
}

export function IcpIcon(): JSX.Element {
	return (
		<SvgIcon>
			<svg viewBox="0 0 360 360" xmlns="http://www.w3.org/2000/svg">
				<linearGradient
					id="a"
					x1="17.42"
					x2="340.07"
					y1="64.563"
					y2="-59.596"
					gradientTransform="matrix(1 0 0 -1 0 182)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#292a2e" offset="0" />
					<stop stopColor="#555" offset="1" />
				</linearGradient>
				<circle cx="180" cy="180" r="180" fill="url(#a)" />
				<path
					d="M254.8 217.4c-15.9 0-32.7-10.4-40.9-17.9-9-8.3-33.8-35.1-33.9-35.2-16.2-18.1-38.1-38.2-59.9-38.2-26.2 0-49.1 18.2-55.1 42.2.5-1.6 8.8-23.6 40.1-23.6 15.9 0 32.7 10.4 40.9 17.9 9 8.3 33.8 35.1 33.9 35.2 16.2 18.1 38.1 38.2 59.9 38.2 26.2 0 49.1-18.2 55.1-42.2-.4 1.5-8.8 23.6-40.1 23.6z"
					fill="#29abe2"
				/>
				<linearGradient
					id="b"
					x1="149.5"
					x2="72.885"
					y1="228.8"
					y2="149.47"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#ed1e79" offset=".22" />
					<stop stopColor="#522785" offset=".892" />
				</linearGradient>
				<path
					d="M180 197.8c-.1-.1-7.2-7.8-15.2-16.2-4.3 5.1-10.5 12.1-17.7 18.4-13.3 11.7-22 14.1-27 14.1-18.7 0-34-14.8-34-33.1 0-18.1 15.2-33 34-33.1.7 0 1.5.1 2.5.2-5.6-2.2-11.6-3.6-17.5-3.6-31.3 0-39.6 22-40.1 23.6-1 4.1-1.6 8.4-1.6 12.8 0 30.3 25 55 56.2 55 13 0 27.6-6.7 42.6-19.8 7.1-6.2 13.2-12.9 17.9-18.2 0 0 0-.1-.1-.1z"
					fill="url(#b)"
				/>
				<linearGradient
					id="c"
					x1="-313.26"
					x2="-389.87"
					y1="-296.51"
					y2="-375.84"
					gradientTransform="rotate(180 -51.404 -81.632)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#f15a24" offset=".21" />
					<stop stopColor="#fbb03b" offset=".684" />
				</linearGradient>
				<path
					d="M180 164.2c.1.1 7.2 7.8 15.2 16.2 4.3-5.1 10.5-12.1 17.7-18.4 13.3-11.7 22-14.1 27-14.1 18.7 0 34 14.8 34 33.1 0 18.1-15.2 33-34 33.1-.7 0-1.5-.1-2.5-.2 5.6 2.2 11.6 3.6 17.5 3.6 31.3 0 39.6-22 40.1-23.6 1-4.1 1.6-8.4 1.6-12.8 0-30.3-25.4-55-56.6-55-13 0-27.2 6.7-42.2 19.8-7.1 6.2-13.2 12.9-17.9 18.2 0 0 0 .1.1.1z"
					fill="url(#c)"
				/>
			</svg>
		</SvgIcon>
	);
}

export const LOGO_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vladiator-labs-logo.png";
export const CHECKMARK_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vido-checkmark.png";
export const SORT_UP_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vido-sort-up.svg";
export const SORT_DOWN_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vido-sort-down.svg";
export const FAVORITE_BLACK_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vido-favorite_black.svg";
export const FAVORITE_WHITE_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vido-favorite_white.svg";
export const LOADING_IMAGE_SOURCE =
	"https://vladiator-labs-ag.imgix.net/vido-loading.svg";
